let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("1bKoS")).then(() => parcelRequire('4zaMV'));